import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import ScoreCircle from '@hydra/common/components/ScoreCircle';
import { Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    display: 'block',
    padding: theme.spacing(2),
    borderSpacing: '5px',
    borderCollapse: 'separate',
    textAlign: 'center'
  },
  labelDate: {
    fontWeight: theme.typography.fontWeightSemibold,
    marginBottom: theme.spacing(1)
  },
  labelScore: {
    display: 'flex',
    justifyContent: 'center'
  }
}));

export const ScoreGraphTooltip = ({ active, payload, label, labelFormatter }) => {
  const classes = useStyles();
  if (active && payload && label) {
    return (
      <div className={classes.root}>
        <div className={classes.labelDate}>{labelFormatter(label)}</div>
        <div className={classes.labelScore}>
          {
            payload[0].value === null
              ? <Translate content='dashboard_score_graph_no_data_tooltip' />
              : <ScoreCircle score={payload[0].value} size='small' />
          }
        </div>
      </div>
    );
  }

  return null;
};

ScoreGraphTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  labelFormatter: PropTypes.func,
  label: PropTypes.number
};

export default ScoreGraphTooltip;
